export default __webpack_public_path__ + "static/media/store_2.b334706c.png";